export class NativeStreamProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "concurrency",
            "baseName": "concurrency",
            "type": "number",
            "format": ""
        },
        {
            "name": "targetFileSizeBytes",
            "baseName": "targetFileSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerTargetFileSizeBytes",
            "baseName": "writerTargetFileSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxBatchAgeSeconds",
            "baseName": "maxBatchAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxPublishAgeSeconds",
            "baseName": "maxPublishAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "compression",
            "baseName": "compression",
            "type": "string",
            "format": ""
        },
        {
            "name": "zstdLevel",
            "baseName": "zstdLevel",
            "type": "number",
            "format": ""
        },
        {
            "name": "sortColumns",
            "baseName": "sortColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "clusterColumns",
            "baseName": "clusterColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "statsColumns",
            "baseName": "statsColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "clusterCurve",
            "baseName": "clusterCurve",
            "type": "NativeStreamClusterCurve",
            "format": ""
        },
        {
            "name": "nodictColumns",
            "baseName": "nodictColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "compactorSampleEncodings",
            "baseName": "compactorSampleEncodings",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "writerSampleEncodings",
            "baseName": "writerSampleEncodings",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bloomFilterColumns",
            "baseName": "bloomFilterColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "bloomFilterWriteMode",
            "baseName": "bloomFilterWriteMode",
            "type": "NativeStreamBloomFilterWriteMode",
            "format": ""
        },
        {
            "name": "bloomFilterFpp",
            "baseName": "bloomFilterFpp",
            "type": "number",
            "format": "double"
        },
        {
            "name": "variantShredding",
            "baseName": "variantShredding",
            "type": "NativeStreamVariantShreddingConfig",
            "format": ""
        },
        {
            "name": "flushConcurrency",
            "baseName": "flushConcurrency",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerConcurrency",
            "baseName": "readerConcurrency",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerPrefetch",
            "baseName": "readerPrefetch",
            "type": "number",
            "format": ""
        },
        {
            "name": "ingressFlowControlMessages",
            "baseName": "ingressFlowControlMessages",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerRowGroupTargetBytes",
            "baseName": "writerRowGroupTargetBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitionIdleSeconds",
            "baseName": "partitionIdleSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitionChannelDepth",
            "baseName": "partitionChannelDepth",
            "type": "number",
            "format": ""
        },
        {
            "name": "commitIntervalSeconds",
            "baseName": "commitIntervalSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxDrainMessages",
            "baseName": "maxDrainMessages",
            "type": "number",
            "format": ""
        },
        {
            "name": "redrainThresholdMessages",
            "baseName": "redrainThresholdMessages",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionConcurrency",
            "baseName": "compactionConcurrency",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionBinPackLane",
            "baseName": "compactionBinPackLane",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "compactionSmallFileRatio",
            "baseName": "compactionSmallFileRatio",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionMinInputFiles",
            "baseName": "compactionMinInputFiles",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionMinBinFillRatio",
            "baseName": "compactionMinBinFillRatio",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionMaxInputFilesPerTask",
            "baseName": "compactionMaxInputFilesPerTask",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionMaxInputBytesPerTask",
            "baseName": "compactionMaxInputBytesPerTask",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionMaxSortedGroupSizeBytes",
            "baseName": "compactionMaxSortedGroupSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionAdmissionMedianInFlightTasks",
            "baseName": "compactionAdmissionMedianInFlightTasks",
            "type": "number",
            "format": ""
        },
        {
            "name": "cleanerCron",
            "baseName": "cleanerCron",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotRetainDays",
            "baseName": "snapshotRetainDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotRetainHours",
            "baseName": "snapshotRetainHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "orphanMinAgeHours",
            "baseName": "orphanMinAgeHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "orphanScanMaxPartitionAgeHours",
            "baseName": "orphanScanMaxPartitionAgeHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "dataRetainDays",
            "baseName": "dataRetainDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "retentionColumn",
            "baseName": "retentionColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "dedupEnabled",
            "baseName": "dedupEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "rawTableEnabled",
            "baseName": "rawTableEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "icebergFormatVersion",
            "baseName": "icebergFormatVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableLocation",
            "baseName": "tableLocation",
            "type": "string",
            "format": ""
        },
        {
            "name": "dedupTtlHours",
            "baseName": "dedupTtlHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerCpuRequest",
            "baseName": "writerCpuRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "writerCpuLimit",
            "baseName": "writerCpuLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "writerMemoryRequest",
            "baseName": "writerMemoryRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "writerMemoryLimit",
            "baseName": "writerMemoryLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerCpuRequest",
            "baseName": "readerCpuRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerCpuLimit",
            "baseName": "readerCpuLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerMemoryRequest",
            "baseName": "readerMemoryRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerMemoryLimit",
            "baseName": "readerMemoryLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "committerCpuRequest",
            "baseName": "committerCpuRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "committerCpuLimit",
            "baseName": "committerCpuLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "committerMemoryRequest",
            "baseName": "committerMemoryRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "committerMemoryLimit",
            "baseName": "committerMemoryLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "compactorCpuRequest",
            "baseName": "compactorCpuRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "compactorCpuLimit",
            "baseName": "compactorCpuLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "compactorMemoryRequest",
            "baseName": "compactorMemoryRequest",
            "type": "string",
            "format": ""
        },
        {
            "name": "compactorMemoryLimit",
            "baseName": "compactorMemoryLimit",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerMinIntervalSeconds",
            "baseName": "readerMinIntervalSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerMaxIntervalSeconds",
            "baseName": "readerMaxIntervalSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerTargetBytes",
            "baseName": "readerTargetBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerBufferBudgetBytes",
            "baseName": "readerBufferBudgetBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerGroupKey",
            "baseName": "readerGroupKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "readerShards",
            "baseName": "readerShards",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerUploadQueueDepth",
            "baseName": "readerUploadQueueDepth",
            "type": "number",
            "format": ""
        },
        {
            "name": "spoolWindowBatches",
            "baseName": "spoolWindowBatches",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerMinReplicas",
            "baseName": "writerMinReplicas",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerMaxReplicas",
            "baseName": "writerMaxReplicas",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerTargetCpuUtilization",
            "baseName": "writerTargetCpuUtilization",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerTargetDrainUse",
            "baseName": "writerTargetDrainUse",
            "type": "number",
            "format": ""
        },
        {
            "name": "writerAgeThresholdSeconds",
            "baseName": "writerAgeThresholdSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactorMinReplicas",
            "baseName": "compactorMinReplicas",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactorMaxReplicas",
            "baseName": "compactorMaxReplicas",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactorTargetCpuUtilization",
            "baseName": "compactorTargetCpuUtilization",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactorTasksPerReplica",
            "baseName": "compactorTasksPerReplica",
            "type": "number",
            "format": ""
        },
        {
            "name": "rowIdentityColumn",
            "baseName": "rowIdentityColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "stats",
            "baseName": "stats",
            "type": "NativeStreamStatsConfig",
            "format": ""
        },
        {
            "name": "sampling",
            "baseName": "sampling",
            "type": "NativeStreamSamplingConfig",
            "format": ""
        },
        {
            "name": "profileSample",
            "baseName": "profileSample",
            "type": "NativeStreamProfileSampleConfig",
            "format": ""
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "NativeStreamSchemaConfig",
            "format": ""
        },
        {
            "name": "transform",
            "baseName": "transform",
            "type": "NativeStreamTransformConfig",
            "format": ""
        },
        {
            "name": "upsert",
            "baseName": "upsert",
            "type": "NativeStreamUpsertConfig",
            "format": ""
        },
        {
            "name": "aggregations",
            "baseName": "aggregations",
            "type": "Array<NativeStreamAggregationConfig>",
            "format": ""
        },
        {
            "name": "spool",
            "baseName": "spool",
            "type": "NativeStreamSpoolConfig",
            "format": ""
        },
        {
            "name": "eventTimeShift",
            "baseName": "eventTimeShift",
            "type": "NativeStreamEventTimeShiftConfig",
            "format": ""
        },
        {
            "name": "onDemandRoles",
            "baseName": "onDemandRoles",
            "type": "Array<NativeStreamRole>",
            "format": ""
        },
        {
            "name": "customImageTag",
            "baseName": "customImageTag",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProperties.attributeTypeMap;
    }
    constructor() {
    }
}
